import React, { Component } from 'react';
import { Container, Typography, Box, ListItem } from "@mui/material";
import { withTranslation, WithTranslation } from "react-i18next";


class AcacursDocumentsPrivacyPolicy extends Component<WithTranslation> {
    openInNewTab = (url: string) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    render() {
        const t = this.props.t;
        return (
            <Container maxWidth="xl" className="pageHeight">

                <Box sx={{ width: "100%", px: { xs: 0, sm: 5, md: 10, lg: 20, xl: 40 } }}>
                    <Typography variant="h3" sx={{ fontWeight: 700, mt: 5 }}>
                        {t("acacursDocuments_privacyPolicyText")}
                    </Typography>
                    <Typography variant="caption" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyTextLatestUpdateText")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_theAppPrivacyPolicyText")}
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyOverviewText")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyOverviewContentText")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsContentText")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem1Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem2Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem3Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem4Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem5Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem6Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem7Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem8Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem9Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem10Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem11Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyDefinitionsAndKeyTermsListItem12Text")}
                    </ListItem>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectContent1Text")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem1Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem2Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem3Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem4Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem5Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem6Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem7Text")}
                    </ListItem>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectContent2Text")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem8Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem9Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem10Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyInformationWeCollectListItem11Text")}
                    </ListItem>

                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseInformationWeCollectTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseInformationWeCollectContentText")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseInformationWeCollectListItem1Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseInformationWeCollectListItem2Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseInformationWeCollectListItem3Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseInformationWeCollectListItem4Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseInformationWeCollectListItem5Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseInformationWeCollectListItem6Text")}
                    </ListItem>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhenShareWithThirdPartiesTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhenShareWithThirdPartiesContentText")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyShareWithThirdPartiesTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyShareWithThirdPartiesContent1Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyShareWithThirdPartiesContent2Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyShareWithThirdPartiesContent3Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyShareWithThirdPartiesContent4Text")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhereAndWhenInformationCollectedTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhereAndWhenInformationCollectedContentText")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseYourEmailAddressTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyHowDoWeUseYourEmailAddressContentText")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyInformationTransferredToOtherCountriesTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyInformationTransferredToOtherCountriesContent")}
                    </Typography>
                      {/*  */}
                      <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyIsInformationCollectedsSecureTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyIsInformationCollectedsSecureContent")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyUpdateOrCorrectInformationTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyUpdateOrCorrectInformationContent")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyPersonnelTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyPersonnelContent")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicySaleofBusinessTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicySaleofBusinessContent")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyAffiliatesTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyAffiliatesContent")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyHowLongWeKeepInformationTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyHowLongWeKeepInformationContent")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyHowWeProtectInformationTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyHowWeProtectInformationContent")}
                    </Typography>

                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyGoverningLawTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyGoverningLawContent")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyYourConsentTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyYourConsentContent")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyLinksToOtherWebsitesTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyLinksToOtherWebsitesContent")}
                    </Typography>
                        {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCookiesTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCookiesContent")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyAdvertisingTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyAdvertisingContent")}
                    </Typography>

                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCookiesForAdvertisingTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCookiesForAdvertisingContent")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyRemarketingServicesTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyRemarketingServicesContent")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyKidsPrivacyTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyKidsPrivacyContent")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyChangesToOurPrivacyPolicyTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyChangesToOurPrivacyPolicyContent")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyThirdPartyServicesTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyThirdPartyServicesContent1Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyThirdPartyServicesContent2Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyThirdPartyServicesContent3Text")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyFacebookPixelTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyFacebookPixelContent")}
                    </Typography>
                      {/*  */}
                      <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyTrackingTechnologiesTitle")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyTrackingTechnologiesListItem1Text")}
                    </ListItem>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyTrackingTechnologiesListItem1ContentText")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyTrackingTechnologiesListItem2Text")}
                    </ListItem>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyTrackingTechnologiesListItem2ContentText")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyTrackingTechnologiesListItem3Text")}
                    </ListItem>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyTrackingTechnologiesListItem3ContentText")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyInformationAboutGDPRTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyInformationAboutGDPRContent")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhatIsGDPRTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhatIsGDPRContent")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhatIsPersonalDataTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhatIsPersonalDataContent")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyWhatIsPersonalDataListItem1Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyWhatIsPersonalDataListItem2Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyWhatIsPersonalDataListItem3Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyWhatIsPersonalDataListItem4Text")}
                    </ListItem>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhyIsGDPRImportantTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyWhyIsGDPRImportantContent")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyIndividualDataSubjectRightsTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyIndividualDataSubjectRightsContent1Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyIndividualDataSubjectRightsContent2Text")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsContent1Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsContent2Text")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsListItem1Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsListItem2Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsListItem3Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsListItem4Text")}
                    </ListItem>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsContent3Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsContent4Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCaliforniaResidentsContent5Text")}
                    </Typography>
                     {/*  */}
                     <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCalOPPATitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAContent1Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAContent2Text")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAListItem1Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAListItem2Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAListItem3Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAListItem4Text")}
                    </ListItem>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAContent3Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAContent4Text")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyCalOPPAContent5Text")}
                    </Typography>
                    {/*  */}
                    <Typography variant="h5" sx={{ fontWeight: 700, my: 3 }}>
                        {t("acacursDocuments_privacyPolicyContactUsTitle")}
                    </Typography>
                    <Typography variant="body1" sx={{ my: 3 }}>
                        {t("acacursDocuments_privacyPolicyContactUsContent")}
                    </Typography>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyContactUsListItem1Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyContactUsListItem2Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyContactUsListItem3Text")}
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        {t("acacursDocuments_privacyPolicyContactUsListItem4Text")}
                    </ListItem>
                </Box>

            </Container>
        );
    };
};

export default withTranslation()(AcacursDocumentsPrivacyPolicy);